<template>
  <ui-dropdown
    top
  >
    <template #toggle="{ toggle }">
      <slot
        name="button"
        :show="() => toggle()"
        :currentPreset="gasPreset"
        :currentPresetName="presets[gasPreset || 'standard']"
      >
        <button
          class="text-xs leading-none dark:text-gray-300 hover:underline"
          @click="toggle"
        >
          Gas Preset: {{ presets[gasPreset || 'standard'] }}
        </button>
      </slot>
    </template>
    <template #default>
      <div class="py-2 px-4 text-xs text-gray-300">
        Gas preset
      </div>
      <ui-dropdown-item
        v-for="(value, key) in presets"
        :key="key"
        :is-active="key === gasPreset"
        @click="setGasPreset($event, key)"
      >
        {{ value }}
      </ui-dropdown-item>
      <hr
        v-if="gasPreset === 'custom'"
        class="my-1 border-gray-700"
      >
      <ui-dropdown-form
        v-if="gasPreset === 'custom'"
        class="pt-2"
      >
        <form autocomplete="off">
          <ui-input-group label="Max Fee per Gas">
            <ui-input
              v-model="maxFeePerGas"
              autocomplete="off"
              :placeholder="formatWei(maxFeePerGasData, 'gwei').toFixed(2)"
            />
          </ui-input-group>
          <ui-input-group label="Max Priority Fee per Gas">
            <ui-input
              v-model="maxPriorityFeePerGas"
              autocomplete="off"
              :placeholder="formatWei(maxPriorityFeePerGasData, 'gwei').toFixed(2)"
            />
          </ui-input-group>
        </form>
      </ui-dropdown-form>
    </template>
  </ui-dropdown>
</template>

<script>
import mapSettings from '@/mixins/mapSettings'
import UiDropdown from './ui/UiDropdown.vue'
import UiDropdownForm from './ui/UiDropdownForm.vue'
import UiDropdownItem from './ui/UiDropdownItem.vue'
import UiInput from './ui/UiInput.vue'
import UiInputGroup from './ui/UiInputGroup.vue'
import { formatWei } from "@/utils/filters";
const GAS_PRESETS = {
  rapid: '⚡️ Instant',
  fast: '🚀 Fast',
  standard: '🚙 Standard',
  custom: '🛠 Custom'
}

export default {
  components: { UiDropdown, UiDropdownItem, UiDropdownForm, UiInputGroup, UiInput },
  mixins: [
    mapSettings({
      gasPreset: { key: `gas.preset`, default: 'fast' },
      maxFeePerGas: {key: 'gas.custom.maxFeePerGas'},
      maxPriorityFeePerGas:  {key: 'gas.custom.maxPriorityFeePerGas'}
    })
  ],
  computed: {
    presets() {
      return GAS_PRESETS;
    },
    gasData() {
      return this.$store.getters['gas/gasData']?.eip1559 || {};
    },
    maxFeePerGasData() {
      return this.gasData?.fast?.maxFeePerGas || "";
    },
    maxPriorityFeePerGasData() {
      return this.gasData?.fast?.maxPriorityFeePerGas || "";
    }
  },
  methods: {
    formatWei,
    setGasPreset(event, preset) {
      if (preset === 'custom') {
        event.stopPropagation();
      }
      if (Object.keys(GAS_PRESETS).indexOf(preset) === -1) {
        throw new Error('Invalid preset selected:', preset);
      }

      this.gasPreset = preset;
    }
  }
}
</script>
